/**
 * Scroll a horizontally scrolling strip just far enough to show `item`.
 *
 * On a phone the navigation and the admin section tabs scroll sideways, and the selected one
 * could sit past the edge — Billing audit and Admin in the main bar, All users in the admin
 * strip — so the reader could not see where they were. Sets `scrollLeft` on the strip itself
 * rather than calling `scrollIntoView`, which would also scroll the page.
 */
export function revealHorizontally(
  strip: HTMLElement | null,
  item: Element | null | undefined,
  margin = 16,
): void {
  if (strip === null || item === null || item === undefined) return;
  if (strip.scrollWidth <= strip.clientWidth) return;
  const bounds = strip.getBoundingClientRect();
  const target = item.getBoundingClientRect();
  if (target.left < bounds.left) strip.scrollLeft -= bounds.left - target.left + margin;
  else if (target.right > bounds.right) strip.scrollLeft += target.right - bounds.right + margin;
}
